import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { Opportunity, OpportunityCategory } from "@api/opportunity";

export type { Opportunity, OpportunityCategory };

export type OpportunityState = {
  categories: OpportunityCategory[];
  opportunities: Opportunity[];
  selectedCategoryId: string | null;
  isLoading: boolean;
  isCategoriesLoading: boolean;
  error: string;
};

const initialState: OpportunityState = {
  categories: [],
  opportunities: [],
  selectedCategoryId: null,
  isLoading: false,
  isCategoriesLoading: false,
  error: "",
};

export const opportunitySlice = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    setOpportunityCategories: (state, { payload }: PayloadAction<OpportunityCategory[]>) => {
      state.categories = payload;
      state.isCategoriesLoading = false;
    },
    setOpportunityCategoriesLoading: (state) => {
      state.isCategoriesLoading = true;
    },
    setSelectedCategory: (state, { payload }: PayloadAction<string>) => {
      state.selectedCategoryId = payload;
    },
    setOpportunities: (state, { payload }: PayloadAction<Opportunity[]>) => {
      state.opportunities = payload;
      state.isLoading = false;
    },
    setOpportunitiesLoading: (state) => {
      state.isLoading = true;
      state.error = "";
    },
    setOpportunityError: (state, { payload }: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = payload;
    },
    clearOpportunitySelection: (state) => {
      state.selectedCategoryId = null;
      state.opportunities = [];
      state.error = "";
    },
    resetOpportunity: () => initialState,
  },
});

export const {
  setOpportunityCategories,
  setOpportunityCategoriesLoading,
  setSelectedCategory,
  setOpportunities,
  setOpportunitiesLoading,
  setOpportunityError,
  clearOpportunitySelection,
  resetOpportunity,
} = opportunitySlice.actions;

export default opportunitySlice.reducer;
